import {useParams, useRouteMatch} from 'react-router-dom';
import {UserCardsAssociations} from '../../../../../../../components/user-cards-associations/user-cards-associations';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';
import {useTranslation} from 'react-i18next';
import {CaregiverPathExtensions} from '../../../../../../../components/caregiver-routes/caregiver-routes';

export default function ProfessionalCaregiverUserCardsProfessionalCaregiverOfficeScreen({
  canWrite,
}: {
  canWrite: boolean;
}) {
  const {t} = useTranslation();
  let {id, entityId}: {id: string; entityId: string} = useParams();
  const officeContext = useOffice();
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <UserCardsAssociations
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWrite}
      entityId={entityId}
      userId={id}
      userName={
        officeContext.state.userForm?.user.displayName ||
        officeContext.state.userForm?.user.name ||
        ''
      }
      associateCardUrl={url.charAt(url.length - 1) === '/' ? `${url}associate` : `${url}/associate`}
      cardRowBaseLinkUrl={url}
      headerTitleCrumbs={[
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs.team
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label: t(
            translations.office.professional_caregiver.profile.generic_header.breadcrumbs
              .professionals
          ),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}`,
        },
        {
          label:
            officeContext.state.userForm?.user.displayName ||
            officeContext.state.userForm?.user.name ||
            '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_ProfessionalCaregivers}/${id}/${CaregiverPathExtensions.Profile}`,
        },
        {
          label: t(translations.screen_paths.senior_user_cards),
          link: url,
        },
      ]}
    />
  );
}
